import { useRouter } from 'next/router'
import { Fragment } from 'react'
import { useTranslation } from 'next-i18next'

import CircleIconButton from '~/bootcamp/components/CircleIconButton'

import { ActivityMenu, LevelActionType } from '~/bootcamp/types/bootcamp.types'
import Button from '~/components/Buttons/Button'
import useBackToCurriculumPath from '~/bootcamp/hooks/useBackToCurriculumPath'
import curriculumAnalytics from '~/analytics/curriculum/curriculumAnalytics'

interface Props {
  courseLevelKeys: string[]
  courseLevels: Record<number, ActivityMenu[]>
  renderPageCards: (page: ActivityMenu, idx: number) => React.ReactElement
}

const VideoCourseGradeView = ({ courseLevelKeys, courseLevels, renderPageCards }: Props): React.ReactElement => {
  const { query } = useRouter()
  const { t } = useTranslation('bootcamp')
  const curriculumPath = useBackToCurriculumPath()

  return (
    <article>
      <CircleIconButton
        className="w-9 h-9 bg-white m-4 mb-0 md:m-6 md:mb-0 xl:m-8 xl:mb-0"
        iconColor="text-purple"
        iconName="arrow-left-bold"
        link={curriculumPath}
      />

      <section className="max-w-screen-sm mx-auto w-full px-4 pb-4 lg:-mt-12">
        {courseLevelKeys.map((menuLevel) => {
          const numericLevel = Number(menuLevel)
          const levelPages: ActivityMenu[] = courseLevels[numericLevel]
          const { level, type } = levelPages[0]

          if (level !== query.level) return null

          if (query.action === LevelActionType.Why && type !== LevelActionType.Why) return null
          if (type === LevelActionType.Why && query.action !== LevelActionType.Why) return null

          return <Fragment key={`menu-${numericLevel}`}>{levelPages.map(renderPageCards)}</Fragment>
        })}
      </section>

      <Button
        className="h-11 w-52 font-bold text-white text-xs mx-auto mt-4 mb-16 border border-white bg-purple rounded"
        href={curriculumPath}
        onClick={() => curriculumAnalytics.logButtonClick('Back to Curriculum')}
      >
        {t('backToMasteryTrack')}
      </Button>
    </article>
  )
}

export default VideoCourseGradeView
